import { makeStyles } from '@material-ui/core';
import hexToRgb from '../../../helpers/ui/coloringHelper';

const useStyles = makeStyles((theme) => ({
  infoContainer: {
    borderRadius: 10,
    backgroundColor: `rgba(${hexToRgb(theme.palette.blue.efesLightBlue)}, 0.03)`,
    marginTop: 30,
    padding: 10,
  },
}));

export default useStyles;
